import CateBox from './src/main';
export default CateBox;


// WEBPACK FOOTER //
// ./src/components/CateBox/index.js